import { GuaranteedOfferType } from '@appTypes/App.interface'

import balanceTransferOfferDurationContent from '@components/CreditCardContent/components/balanceTransferOfferDurationContent'
import guaranteedAprContent from '@components/CreditCardContent/components/guaranteedAprContent'
import minimumGuaranteedCreditLimitContent from '@components/CreditCardContent/components/minimumGuaranteedCreditLimitContent'
import noMinimumGuaranteedCreditLimitContent from '@components/CreditCardContent/components/noMinimumGuaranteedCreditLimitContent'
import purchaseOfferDurationContent from '@components/CreditCardContent/components/purchaseOfferDurationContent'
import representativeAprContent from '@components/CreditCardContent/components/representativeAprContent'
import transferFeeContent from '@components/CreditCardContent/components/transferFeeContent'
import isZableProduct from '@components/CreditCardContent/utils/isZableProduct'

import getGuaranteedOfferType from '@utils/getGuaranteedOfferType'

import { ContentProps } from './Content.interface'

const getBestCardsContent = ({ creditCard }: ContentProps) => {
    const guaranteedOfferType = getGuaranteedOfferType({
        creditCard: creditCard,
    })

    const isTotallySureOffer =
        guaranteedOfferType === GuaranteedOfferType.MarketingOffer

    const shouldHideCreditLimit =
        !isTotallySureOffer && isZableProduct(creditCard.productCode)

    return [
        guaranteedAprContent({ creditCard }),
        minimumGuaranteedCreditLimitContent({ creditCard }),
        representativeAprContent({ creditCard }),
        !shouldHideCreditLimit
            ? noMinimumGuaranteedCreditLimitContent({
                  creditCard,
              })
            : null,
        balanceTransferOfferDurationContent({ creditCard }),
        purchaseOfferDurationContent({ creditCard }),
        transferFeeContent({ creditCard }),
    ]
}

export default getBestCardsContent
